// ÚNICO PONTO DE TROCA DOS CONTATOS.
// `whatsapp` é o número no formato internacional, só dígitos (55 + DDD + número),
// como o wa.me exige. `telefoneExibicao` é o que aparece na tela.
export const CONTATO = {
  whatsapp: '5511927023562',
  telefoneExibicao: '(11) 92702-3562',
  email: 'atendimentoflordegoias@intermediacoesb2b.com.br',
}

// Dados cadastrais conforme Receita Federal (CNPJ 27.221.165/0001-40).
export const EMPRESA = {
  nome: 'Flor de Goiás Transportadora',
  razao: 'Flor de Goiás Assessoria e Serviços de Apoio Administrativo Ltda. – EPP',
  cnpj: '27.221.165/0001-40',
  fundacao: '03/03/2017',
  natureza: 'Sociedade empresária limitada',
  situacao: 'Ativa',
  cnae: 'Transporte rodoviário de produtos perigosos',
  cnaeCodigo: '4930-2/03',
  endereco: 'Av. Conselheiro Carrão, 1624 – 1º andar, sala',
  bairro: 'Vila Carrão',
  cidade: 'São Paulo/SP',
  cep: '03402-001',
  horario: 'Seg–Sex, 9h–18h',
}

export function waLink(texto = 'Olá! Vim pelo site da Flor de Goiás Transportadora e gostaria de mais informações.') {
  return `https://wa.me/${CONTATO.whatsapp}?text=${encodeURIComponent(texto)}`
}
